import { useEffect, useState } from 'react';
import { WEB_SCHEMA } from '../../../constants/componentStaticData';
import { GuidesAndLinksData } from '../../../constants/partnerPageConst';
import { Meta } from '../../../layout/Meta';
import { handleTrack } from '../../../utils/tracker';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { MarktechModal } from '../../Atoms/Modal';
import { FaqComponent } from '../../Common/FAQS';
import { GuidesAndUsefullLink } from '../../Common/GuidesAndUsefullLink';
import { GreySection } from '../../Common/Section/GreySection';
import { LoginButton } from '../../Header/LoginButton';
import { ClearInNavbar } from '../../Navbar/ClearNavbar';
import { generateSSOLinkWithReturnPath } from '../../cms/layout/comment-section/utils/utils';
import { b2cData } from '../../cms/layout/components/header';
import { PricingCardStaticDetails } from '../../partner-pages/page-sections/eas-section/expertPlans/card-details.constants';
import { PartnerRewards } from '../../partner-pages/page-sections/rewards-section/partner-rewards';
import { DrawerLeadForm } from './components/drawer-form/drawer_form';
import { getEASPlanList } from './components/eas_fold/utils';
import { HeroComponent } from './components/hero-component/hero-fold.component';
import { Questionaire } from './components/interactive_faq_fold/Questionaire';
import { LuxuryTaxSupport } from './components/luxury-tax-support/luxury-tax-support.component';
import { PricingCardWrapper } from './components/pricing-card/pricing-card-carousel/pricing-card-carousel.component';
import { ShowCasedFold } from './components/showcased_fold';
import { TestimonialFold } from './components/testimonial_fold';
import { pricingFaq } from './constants';
import { useDataForPlansPricing } from './pricing.hooks';
import { IPricing } from './types';
import { useHashScroll } from '../../partner-pages/hooks/useScrollHook';
export const PricingPage: React.FC<IPricing> = ({
  PAID_PAGE = false,
  pricePageData,
}): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loginLink, setLoginLink] = useState('');
  useHashScroll(69);
  useEffect(() => {
    const returnPath = `/s/pricing`;
    const loginLink = generateSSOLinkWithReturnPath(returnPath, 'af');
    setLoginLink(loginLink);
  }, []);

  const pricingPlanData = useDataForPlansPricing(
    pricePageData?.eas_plans ? getEASPlanList(pricePageData.eas_plans) : []
  );

  if (!pricePageData) {
    return <></>;
  }

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      handleTrack({
        label: 'chat-open',
      });
    }
  };
  return (
    <>
      <Meta
        canonical="/s/pricing/"
        title={pricePageData.metaTitle}
        description={pricePageData.metaDescription}
        keywords={pricePageData.metaKeywords}
        key="robots"
        noindex={PAID_PAGE}
        nofollow={PAID_PAGE}
        img="https://assets.clear.in/cleartax/images/1753522661_af_pricingpage.png"
      />
      <ClearInNavbar
        data={{
          ...b2cData,
          rightCTA: <LoginButton link={loginLink} />,
        }}
        customCTALink={loginLink}
      />
      <div>
        <div className="pricingCardComponent wg-container">
          <HeroComponent />
          <PricingCardWrapper
            pricingPlanData={pricingPlanData}
            PricingCardStaticDetails={PricingCardStaticDetails}
          />
          <LuxuryTaxSupport
            utm_ref="plan_card_pricing_page_luxury"
            heading_1="Luxury Tax Support, All Year Round"
            description={[
              'All-inclusive personal tax expert at your service',
              '24*7 / 365 days, calls & live sessions',
              'All Complex Tax Compliances ',
              'Tailored for high income earners & business owners',
              'Includes benefit of all other plans ',
            ]}
            price="₹24,999"
          />
        </div>

        <DrawerLeadForm
          toggleIsOpen={toggleIsOpen}
          isOpen={isOpen}
          partnerName="pricing-page"
        />
        <div className="stickyCTA fixed bottom-0 left-0 z-100 sm:flex sm:justify-between hidden bg-white w-full px-6 py-3">
          <a
            href="#pricing-card"
            className="flex-1"
            onClick={(e) =>
              handleTrack({
                label: 'sticky_cta',
                obj: e.target,
              })
            }
          >
            <Button
              variant={ButtonVariants.bluebordered}
              rounded="md"
              className="px-6 py-4 text-s-base w-full"
            >
              View plans
            </Button>
          </a>
          {/* <Button
            onClick={(e) => {
              setIsModalVisible(!isModalVisible);
              handleTrack({
                label: 'sticky-cta',
                obj: e.target,
              });
            }}
            variant={ButtonVariants.bluebordered}
            rounded="md"
            className="ml-3 bg-white px-6 py-4 text-s-base"
          >
            Recommend a plan
          </Button> */}
        </div>
        <div className="wg-container">
          <ShowCasedFold showcaseFold={pricePageData.showcased_plan} />
        </div>
      </div>
      <PartnerRewards />
      <div className="wg-container">
        <TestimonialFold />
      </div>

      <GreySection>
        <GuidesAndUsefullLink
          heading={GuidesAndLinksData.heading}
          cards={GuidesAndLinksData.cards}
        />
      </GreySection>

      <div className="wg-container">
        <FaqComponent
          heading="FAQs"
          variant="partner"
          expanded="firstOnly"
          FAQS={pricingFaq}
          faqIconColor={'#314259'}
          isShowSchema={true}
        />
      </div>
      <MarktechModal
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeIcon={'✕'}
        classNames={{
          modal:
            'qnaMaxWidth mobile-bottom-fixed mobile-search-box rounded-2xl h-fit max-h-[95vh] overflow-hidden w-full',
          closeButton: 'text-s-24',
        }}
      >
        <div className="modal rounded-xl modal-open bg-[#F9FAFB]">
          <Questionaire
            leadDetails={{
              type: 'plan-selection-form',
              sheetName: 'PlanSelectionQA',
            }}
          />
        </div>
      </MarktechModal>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            WEB_SCHEMA({
              title: pricePageData.metaTitle,
              metaDesc: pricePageData.metaDescription,
              url: 'https://cleartax.in/s/pricing/',
            })
          ),
        }}
      ></script>
    </>
  );
};
